import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=0a3679b6&scoped=true&"
import script from "./goodsEdit.js?vue&type=script&lang=js&"
export * from "./goodsEdit.js?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=0a3679b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3679b6",
  null
  
)

export default component.exports